import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import heroImage from "@/assets/hero-sustainability-optimized.jpg";
import { useLangPath } from "@/hooks/use-lang-path";

const HeroSection = () => {
  const { t } = useTranslation();
  const lp = useLangPath();
  return (
    <section className="relative min-h-screen flex items-end pb-20 overflow-hidden">
      <img
        src={heroImage}
        alt="Sustainable infrastructure with renewable energy sources including wind turbines, solar panels, and electric vehicles"
        loading="eager"
        decoding="async"
        fetchPriority="high"
        sizes="100vw"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-white/80" />

      <div className="relative z-10 container-narrow px-6 w-full max-w-full overflow-hidden">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          className="max-w-3xl lg:ml-[12%] xl:ml-[16%]"
        >
          <p className="text-muted-foreground text-xs lg:text-sm font-display tracking-[0.3em] lg:tracking-[0.35em] uppercase mb-10">
            {t("hero.eyebrow")}
          </p>
          <h1 className="font-display text-[2.25rem] sm:text-5xl lg:text-7xl xl:text-8xl font-bold leading-[1.05] tracking-tight text-foreground mb-8 [hyphens:none] [overflow-wrap:normal] [word-break:normal]">
            {t("hero.title")}
          </h1>
          <p className="text-muted-foreground text-base sm:text-lg md:text-xl max-w-2xl leading-relaxed mb-12">
            {t("hero.subtitle")}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to={lp("/contact")}>
              <Button size="lg">{t("hero.cta")}</Button>
            </Link>
          </div>
          {/* <HeroTrustedStrip /> */}
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
